import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Input, ValidationGroup } from '@bingads-webui-react/primitive-validation';

export class NumberInput extends React.PureComponent {
    static propTypes = {
      i18n: PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      newI18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func,
      }),
      reasonId: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired,
      comment: PropTypes.string,
    };

    static defaultProps = {
      newI18n: {
        getString: _.noop,
      },
      comment: '',
    };

    constructor(props) {
      super(props);
      this.state = { value: '' };
      this.schema = {
        properties: {
          Number: {
            blockInput: false,
            type: 'number',
            nullable: true,
            maxLength: 128,
            minimum: 0.00,
          },
        },
      };
    }

    handleChange=(e) => {
      this.setState({
        value: e.target.value,
      });
      this.props.callback(e.target.value);
    };


    render() {
      const {
        reasonId, newI18n, i18n, comment,
      } = this.props;
      const { value } = this.state;
      const isNewI18n = newI18n.getString !== _.noop;
      return (
        <ValidationGroup validationProps={{
            schema: this.schema,
            i18n,
          }}
        >
          <div className="input-comment">
            {i18n.getString(comment)}
          </div>
          <Input
            placeholder={isNewI18n ? newI18n.getString(_TL_('optional')) : i18n.getString('Budget_Landscape_Number_Input_Placeholder')}
            validationProps={{
                          field: 'Number',
                        }}
            className="number-input"
            id={`${reasonId}-number-input`}
            value={value}
            onChange={this.handleChange}
            field="Number"
          />
        </ValidationGroup>
      );
    }
}
